export const EMAIL_REGEX =
  /^\s*[-!#$%&'*+/0-9=?_a-z`{|}~](\.?[-!#$%&'*+/0-9=?_a-z`{|}~])*@[a-z0-9](-*\.?[a-z0-9])*\.[a-z](-?[a-z0-9])+\s*$/;
export const HAS_NUMBER_REGEX = /^(?=.*\d).*$/;
export const HAS_LOWERCASE_REGEX = /^(?=.*[a-z]).*$/;
export const HAS_UPPERCASE_REGEX = /^(?=.*[A-Z]).*$/;
export const HAS_EIGHT_CHARS_REGEX = /^(?=.{8,}).*$/;
export const HAS_SPECIAL_CHAR_REGEX = /^(?=.*[#$^+=!*()@%&]).*$/;
export const HAS_UPPERCASE_AND_LOWERCASE_REGEX = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.{8,})(?=.*\d)(?=.*[#$^+=!*()@%&]).*$/;
export const TEXT_REGEX =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{1,}$/;
export const ZIP_REGEX = /^[0-9]{4,5}$/;
export const PHONE_NUMBER_REGEX = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s.0-9]*$/;
export const FREQUENTLY_USED_EMAILS = [
  'gmail.com',
  'orange.fr',
  'hotmail.com',
  'icloud.com',
  'live.fr',
  'free.fr',
  'yahoo.fr',
  'aol.com',
  'club-internet.fr',
  'outlook.com',
  'laposte.net',
  'neuf.fr',
  'wanadoo.fr',
  'sfr.fr',
  'bbox.fr',
  'hotmail.fr',
];
export const DIGIT_REGEX = /^[\d +]*$/;

export const handleKeyDownForRegex = (regex) => (e) => {
  if (
    e.ctrlKey ||
    e.altKey ||
    typeof e.key !== 'string' ||
    e.key.length !== 1
  ) {
    return;
  }

  if (e.key && !regex.test(e.key)) {
    e.preventDefault();
  }
};

export const KEY_CODES = {
  ENTER: 13,
};
